import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PagerComponent} from '../paginator/pager.component';

/** AngularMaterial **/
import { MatTableModule, MatButtonModule, MatIconModule,
  MatProgressBarModule, MatSnackBarModule, MatListModule, MatCardModule } from '@angular/material';
import { EstudoListSelectionComponent } from './estudo-list-selection.component';


@NgModule({
    declarations: [
      EstudoListSelectionComponent
    ],
    exports: [
      EstudoListSelectionComponent
    ],
    imports: [
      FormsModule, CommonModule,
      MatButtonModule,  MatProgressBarModule, MatSnackBarModule, MatTableModule, MatIconModule, MatCardModule, MatListModule
    ],
    providers: [
      PagerComponent
    ]
})
export class EstudoListSelectionModule {

}
